const objectPath = require('object-path')
const utils = require('../utils')

export const getConvoById = (state) => id => {
  return utils.find(state.conversations, convo => convo.id === id)
}

export const countUnseenMessageByConvoId = (state) => convoId => {
  if (!convoId) return 0

  let totalUnseen = 0
  const userId = state.user.id
  const events = state.convoEvents[convoId] || []
  for (const event of events) {
    const byId = objectPath.get(event, 'by.id', '')
    if (byId === userId || event.type !== 'message_sent') continue

    let seen = false
    const seenMembers = objectPath.get(event, 'data.message.computed.seen', [])
    seenMembers.forEach(member => {
      if (member.member_id === userId) seen = true
    })

    if (!seen) totalUnseen++
  }

  return totalUnseen
}

export const messagesSentByConvoId = (state) => convoId => {
  if (!convoId) return []
  const events = state.convoEvents[convoId] || []
  return events.filter(event => event.type === 'message_sent') || []
}

export const countUnseenConvos = (state, getters) => convoId => {
  let total = 0
  state.conversations.forEach(convo => {
    let unseen = getters.countUnseenMessageByConvoId(convo.id)
    if (unseen > 0 && convo.id !== convoId) total++
  })

  return total
}

export const convoIds = state => {
  var ids = []
  state.conversations.forEach(convo => (ids[convo.id] = true))
  return ids
}

export const eventIds = state => {
  const ids = {}
  const convoEvents = state.convoEvents || {}

  state.conversations.forEach(convo => {
    const events = convoEvents[convo.id]
    if (!events) return
    events.forEach(event => {
      ids[event.id] = true
    })
  })

  return ids
}

export const seenEventIds = state => {
  const ids = {}
  const userId = state.user.id
  const convoEvents = state.convoEvents || {}

  for (const convo of state.conversations) {
    const events = convoEvents[convo.id] || []

    for (const event of events) {
      const byId = objectPath.get(event, 'by.id', '')
      if (byId === userId || event.type !== 'message_sent') {
        continue
      }

      const seenMembers = objectPath.get(
        event,
        'data.message.computed.seen',
        []
      )
      for (const member of seenMembers) {
        if (member.member_id === userId) {
          ids[event.id] = true
        }
      }
    }
  }

  return ids
}

export const lastUnseenMessage = state => {
  const result = {
    text: '',
    avatarURL: '',
    convoId: '',
    agentInfo: '',
    id: '',
    created: ''
  }

  const userId = state.user.id
  const total = utils.size(state.conversations)
  let conversations = utils.orderBy(state.conversations, 'actived', 'desc')
  for (let i = total - 1; i >= 0; i--) {
    const convo = conversations[i]
    const events = state.convoEvents[convo.id] || []

    for (const event of events) {
      const byId = objectPath.get(event, 'by.id', '')
      const displayId = objectPath.get(event, 'by.display_id', '')
      if (byId === userId || event.type !== 'message_sent') {
        continue
      }

      const seenMembers = objectPath.get(
        event,
        'data.message.computed.seen',
        []
      )
      let seen = false

      for (const member of seenMembers) {
        if (member.member_id === userId) {
          seen = true
        }
      }
      if (!seen) {
        const agent = utils.find(state.agents, item => item.id === (displayId || byId))
        if (agent) {
          result.text = objectPath.get(event, 'data.message.text', '')
          result.avatarURL = agent.avatar_url
          result.convoId = convo.id
          result.id = objectPath.get(event, 'id', '')
          result.agentInfo = agent
          result.created = objectPath.get(event, 'created', '')
        }
      }
    }
  }
  return result
}

export const receivedEventIds = state => {
  const ids = {}
  const userId = state.user.id
  const convoEvents = state.convoEvents || {}

  for (const convo of state.conversations) {
    const events = convoEvents[convo.id] || []

    for (const event of events) {
      const byId = objectPath.get(event, 'by.id', '')
      if (byId === userId || event.type !== 'message_sent') {
        continue
      }

      const receivedMembers = objectPath.get(
        event,
        'data.message.computed.received',
        []
      )
      for (const member of receivedMembers) {
        if (member.member_id === userId) {
          ids[event.id] = true
        }
      }
    }
  }

  return ids
}

export const countryCode = (state) => {
  let countryCode = objectPath.get(state.user, 'traces.0.country_code', '')
  if (!countryCode) {
    countryCode = objectPath.get(state.geoIP, 'country_code', '')
  }
  return countryCode
}

export const languageCode = (state, getters) => {
  let languageCode = 'en-US'
  const countryCode = getters.countryCode.toLowerCase()
  if (countryCode === 'vn') {
    languageCode = 'vi-VN'
  }
  return languageCode
}
